export default __webpack_public_path__ + "static/media/home-taltk-to-us-video.ad280d03.mp4";